const base64 = require('base-64');
const utf8 = require('utf8');

module.exports = {
    getMarketingPermissions : function() {
        let domainInfo = window.localStorage.getItem('domainInfo');

        if (window.uornorb(domainInfo)) {
            return {};
        }

        domainInfo = JSON.parse(domainInfo);
        let permissionsIndex = {};
        // gotta manually build each one, cus it may or may not exist,
        // and they also have custom images

        // phone and post is always hardcoded via defaults

        // sms and email
        if (!window.uornorb(domainInfo.canContactApplicantBySMSAndEmail)) {
            permissionsIndex.canContactApplicantBySMSAndEmail = {
                "image" : "/images/SMS-and-Email.svg",
                "text" : domainInfo.canContactApplicantBySMSAndEmail
            };
        }

        // agent x - third party optional
        if (!window.uornorb(domainInfo.canContactThirdPartyOptional)) {
            permissionsIndex.canContactThirdPartyOptional = {
                "image" : null,
                "text" : domainInfo.canContactThirdPartyOptional
            };
        }

        // agent x - third party mortgage
        if (!window.uornorb(domainInfo.canContactThirdPartyMortgage)) {
            permissionsIndex.canContactThirdPartyMortgage = {
                "image" : null,
                "text" : domainInfo.canContactThirdPartyMortgage
            };
        }

        return permissionsIndex;
    },

    getThirdPartyData : function() {
        let domainInfo = window.localStorage.getItem('domainInfo');

        if (window.uornorb(domainInfo)) {
            return null;
        }

        domainInfo = JSON.parse(domainInfo);

        if (window.uornorb(domainInfo.thirdParty)) {
            return null;
        }

        const regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/g;

        // return either the raw value, or decode the base 64 and return the json
        if (domainInfo.thirdParty.match(regex)) {
            return {
                isJson : true,
                payload : JSON.parse(utf8.decode(base64.decode(domainInfo.thirdParty))),
            };
        }

        return {
            isJson : false,
            payload : domainInfo.thirdParty,
        };
    }
};



// WEBPACK FOOTER //
// ./src/components/Managers/DomainInfo.js